document.addEventListener("DOMContentLoaded", function () {
  const toggleMenus = document.querySelectorAll(".js-toggle-menu");
  toggleMenus.forEach(title => {
    title.addEventListener("click", function () {
      if (window.innerWidth <= 767) {
        const clickedMenu = title.nextElementSibling;
        toggleMenus.forEach(otherTitle => {
          const otherMenu = otherTitle.nextElementSibling;
          if (otherMenu && otherMenu.classList.contains("js-menu-list")) {
            if (otherTitle === title) {
              otherMenu.classList.toggle("sm-max:hidden");
              otherTitle.classList.toggle("toggleactive");
            } else {
              otherMenu.classList.add("sm-max:hidden");
              otherTitle.classList.remove("toggleactive");
            }
          }
        });
      }
    });
  });

  var size_tabs = document.querySelectorAll('.table-nav li');
  if(size_tabs.length > 0){
    size_tabs.forEach(function(tab){
      tab.addEventListener('click',function(e){
        e.preventDefault();
        size_tabs.forEach(function(target){
          target.classList.remove('active');
        })
        this.classList.add('active');
        var data_set = this.querySelector('a').dataset.href;
        document.querySelectorAll('.innerTbContent .table-item').forEach(function(table){
          table.style.display = 'none';
        })
        if(document.getElementById(data_set)){
          document.getElementById(data_set).style.display = 'block';
        }
      })
    })
  }
});

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("reset-filters-btn")) {
    const drawer = document.querySelector("facets-drawer");
    if (drawer) drawer.removeAttribute("open");
    const clearAll = document.querySelector(".active-facets .facet-link-clear-all");
    if (clearAll) {
      clearAll.click();
    } else {
      window.location.href = window.location.pathname;
    }
  }
});

// 2026-04-23 — Removed random_numbers() / `.dynamic_number` fake-viewer-count injector
// per impeccable audit P0-1. Fabricated social proof, FTC-relevant.